import React from 'react';

//own
import Container from "./../../../containers/Container";
import ListSquareCard from '../../../packages/base-components/ListSquareCard';
import categoriesPvc from './categories';
import './styles.scss';

const Pvc = () => 
        (
            <Container>
               <ListSquareCard section='pvc' categories={categoriesPvc} />
            </Container>
        );

export default Pvc;